import React, { FC, useState, useEffect, useId } from 'react';
import Select, { SelectProps, Option } from './Select';
import { Controller, useForm } from 'react-hook-form';
interface Props extends SelectProps {
  className?: string;
  inputClassName?: string;
  labelClassName?: string;
  controlClassname?: string;
  control: ReturnType<typeof useForm>['control'];
  required?: string;
  setValue?: ReturnType<typeof useForm>['setValue'];
  controlledValue?: Option;
  defaultValue?: Option;
  isMulti?: boolean;
  id: string;
}

const SelectWithController: FC<Props> = ({
  control,
  name,
  onInputChange,
  onChange,
  register,
  required,
  setValue,
  controlledValue,
  defaultValue,
  isMulti,
  ...restProps
}) => {
  const [inputValue, setInputValue] = useState(null);
  const generatedId = useId();

  const updateValue = (arg, isMulti = false) => {
    setInputValue(arg);

    const newValue = isMulti
      ? arg.map((v) => {
          return v.value;
        })
      : arg.value;
    setValue(name, newValue, {
      shouldValidate: true,
    });
  };

  useEffect(() => {
    setInputValue(controlledValue);
  }, [controlledValue]);

  useEffect(() => {
    if (defaultValue) {
      updateValue([defaultValue]);
    }
  }, []); // eslint-disable-line

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={{ required: required }}
      // pull out ref as Select doesn't support it - upgrade for threads5 maybe?
      render={({ field: { ref, ...field } }) => {
        return (
          <Select
            {...restProps}
            {...field}
            {...(restProps.id ? { id: `${restProps.id}-${generatedId}` } : {})}
            name={name}
            onInputChange={onInputChange}
            onChange={(arg) => {
              if (onChange) {
                onChange(arg);
              }
              updateValue(arg, isMulti);
            }}
            value={inputValue}
            isMulti={isMulti}
          />
        );
      }}
    />
  );
};

SelectWithController.displayName = 'SelectWithController';
export default SelectWithController;
